var _title, _g, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRoundedTag = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4e3f373-63fd-4849-a86e-b532b04cbbf4",
    "data-name": "Layer 1",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-rounded-tag-hollow")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,.5A4.50508,4.50508,0,0,1,27.5,5V23A4.50508,4.50508,0,0,1,23,27.5H5A4.50508,4.50508,0,0,1,.5,23V5A4.50508,4.50508,0,0,1,5,.5H23M23,0H5A5,5,0,0,0,0,5V23a5,5,0,0,0,5,5H23a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    fill: "#333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.795,16.179l-5.61109,5.6111a1.564,1.564,0,0,1-2.21176,0l-.00123-.00123-6.2495-6.24223A1.60715,1.60715,0,0,1,7.25,14.40955V7.25172h7.15838a1.60713,1.60713,0,0,1,1.13642.47072L21.795,13.9726A1.56481,1.56481,0,0,1,21.795,16.179Z",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1593,
    cy: 11.16102,
    r: 0.9375,
    fill: "#333"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundedTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rounded-tag.72bda465.svg";
export { ForwardRef as ReactComponent };